import { render } from "./SavedBatch.vue?vue&type=template&id=2c1499ac&scoped=true"
import script from "./SavedBatch.vue?vue&type=script&lang=js"
export * from "./SavedBatch.vue?vue&type=script&lang=js"

import "./SavedBatch.vue?vue&type=style&index=0&id=2c1499ac&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c1499ac"]])

export default __exports__